import UseCase, { NoParams } from "../../core/useCase/UseCase";
import { User } from "../entity/User";
import { UserRepository } from "../repository/UserRepository";

export default class GetUser extends UseCase<User, NoParams> {
  repository: UserRepository;

  constructor(repository: UserRepository) {
    super();
    this.repository = repository;
  }

  execute = () => this.repository.getUser();
}
